import React from 'react';
import PropTypes from 'prop-types';
import { numberFormat } from '@fiverr-private/localization';
import { getContext } from '@fiverr-private/fiverr_context';
import { appTranslate } from '../../utils';
import { getRatingPrecision } from '../../../utils/ratingPrecision';
import InlineStarSvg from './inlineStarSvg';
import { MAX_COUNT } from './constants';
import './index.scss';

const Rating = ({ rating, count }) => {
    if (!rating) {
        return <div className="rating-wrapper"></div>;
    }
    const { abTests = {} } = getContext();
    const formattedRating = numberFormat(rating, {
        fallbackValue: rating,
        ...getRatingPrecision(Number(rating), abTests),
    });
    const formattedCount = count > MAX_COUNT ? Math.floor(count / 1000) : count;
    const countText =
        count > MAX_COUNT
            ? appTranslate('gig_cards.count_format', { params: { count: formattedCount } })
            : formattedCount;

    return (
        <div className="rating-wrapper">
            <span className="gig-rating text-body-2">
                <InlineStarSvg />
                {formattedRating}
                <span>{countText}</span>
            </span>
        </div>
    );
};

Rating.propTypes = {
    rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    count: PropTypes.number,
};

export default Rating;
